import React from 'react'
import './footer.css'
import { FiMapPin, FiPhone, FiMail  } from "react-icons/fi";

function Footer({language, scrollToAbout, scrollToServices, scrollToContact}) {
    return (
        <footer>
            <div className='footer_container'>
                <div className='footer_inner'>
                    <div className='footer_text'>
                        <img style={{scale: '0.5'}} src='Logo_white.png' alt="Logo"/>
                        <p><FiMapPin style={{color: '#fca311'}}/> 105 Buckesfelder Str. Lüdenscheid, 58509 North Rhine-Westphalia</p>
                        <p><FiPhone style={{color: '#fca311'}}/> +49 (0) 2674 / 6847241</p>
                        <p><FiMail style={{color: '#fca311'}}/> contact@domain.eu</p>
                        <p>{language === 'deutsch' ? '@ 2024 BusinessName. Alle Rechte vorbehalten' : '@ 2024 BusinessName. All right reserved'}</p>
                    </div>
                    <div style={{display: 'flex', flexDirection: 'column'}} className='nav'>
                        <p onClick={scrollToAbout}>{language === 'deutsch' ? 'Über uns' : 'About us'}</p>
                        <p onClick={scrollToServices}>{language === 'deutsch' ? 'Leistungen' : 'Services'}</p>
                        <p onClick={scrollToContact}>{language === 'deutsch' ? 'Kontakt' : 'Contact'}</p>
                    </div>
                </div>
                <p></p>
            </div>
        </footer>
    )
}

export default Footer